const LOAD_DATA_PARTNERS           = 'LOAD_DATA_PARTNERS'
const LOAD_DATA_PARTNERS_SUCCESS   = 'LOAD_DATA_PARTNERS_SUCCESS'
const LOAD_DATA_PARTNERS_FAILED    = 'LOAD_DATA_PARTNERS_FAILED'
const UNMOUNT_DATA_PARTNERS        = 'UNMOUNT_DATA_PARTNERS'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const partnersReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_PARTNERS:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_PARTNERS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_PARTNERS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_PARTNERS:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default partnersReducer;